// @flow

import React, { Component } from 'react';
//types
import {
  type Currencies,
  type Currency,
  type TooltipProps
} from '../../../utilities/types';
import { type ReferredPartner } from '.';
import { ModelListTd } from '../../../components/ModelListStyles';
import { Default, Mobile } from '../../../components/Responsive';
import { formatCurrency } from '../../../utilities/numberFormatting';
import { DefaultIcon } from '../../../components/Icon';
import styled, { css } from 'styled-components';
import IconWithText from '../../../components/IconWithText';
import TableRowPartial from '../../../modules/CrudTable/components/TableRowPartial';
import { SubtitleP } from '../../../modules/CrudTable/CrudTableStyles';
type Props = {
  index: number,
  tableBodyOptions: {
    summary: {
      tableTotal: number,
      totalProcessingVolUsd: number,
      totalFeesUsd: number,
      partnerCurrency: Currency,
      ...$Exact<TooltipProps>
    }
  },
  data: ReferredPartner,
  currencies: Currencies
};

const CustomModelListTd = styled(ModelListTd)`
  text-transform: uppercase;
  && {
    border-bottom: 0;
  }
  ${props =>
    props.bold &&
    css`
      font-weight: 500;
      ${props => props.theme.fontStackHeader};
      > div {
        > p {
          font-weight: 500;
          ${props => props.theme.fontStackHeader};
        }
      }
    `}
`;

export default class TableRow extends Component<Props> {
  render() {
    const currency = this.props.currencies[this.props.data.currency];
    const currencyName =
      currency.currency_type === 'fiat' ? currency.iso4217 : currency.name;
    const tableTotal = this.props.tableBodyOptions.summary.tableTotal;
    const lastRow = this.props.index === tableTotal - 1;
    return (
      <>
        <TableRowPartial
          id={this.props.data.id}
          options={{
            col1: (
              <ModelListTd>
                <DefaultIcon
                  name={currency.iso4217.toLowerCase()}
                  color={currency.color}
                />
                {currencyName}
              </ModelListTd>
            ),
            col2: (
              <>
                <Default>
                  <ModelListTd right>
                    {formatCurrency(
                      this.props.data.transaction_amount,
                      currency
                    )}
                  </ModelListTd>
                </Default>
                <Mobile>
                  <ModelListTd>
                    {formatCurrency(
                      this.props.data.transaction_amount,
                      currency
                    )}
                    <Mobile>
                      <SubtitleP color="dustierGray">
                        Fees:{' '}
                        {formatCurrency(
                          this.props.data.transaction_fee,
                          currency
                        )}
                      </SubtitleP>
                    </Mobile>
                  </ModelListTd>
                </Mobile>
              </>
            ),
            col3: (
              <ModelListTd right>
                {formatCurrency(this.props.data.transaction_fee, currency)}
              </ModelListTd>
            ),
            col4: (
              <ModelListTd right>
                {formatCurrency(this.props.data.revenue_share, currency)}
              </ModelListTd>
            )
          }}
        />

        {lastRow && (
          <TableRowPartial
            id={lastRow + 1}
            options={{
              col1: (
                <CustomModelListTd bold>
                  <IconWithText
                    message={
                      'This is an estimated amount in USD based on the exchange rate at the time of purchase.'
                    }
                    label={'total'}
                    activeTooltip={
                      this.props.tableBodyOptions.summary.activeTooltip
                    }
                    tooltipName={'partners/show/TOTAL_TOOLTIP'}
                    showTooltip={
                      this.props.tableBodyOptions.summary.showTooltip
                    }
                    smallIcon
                    iconRight
                  />
                </CustomModelListTd>
              ),
              col2: (
                <>
                  <Default>
                    <CustomModelListTd bold right>
                      {formatCurrency(
                        this.props.tableBodyOptions.summary
                          .totalProcessingVolUsd,
                        this.props.currencies['USD']
                      )}
                    </CustomModelListTd>
                  </Default>
                  <Mobile>
                    <CustomModelListTd bold>
                      {formatCurrency(
                        this.props.tableBodyOptions.summary
                          .totalProcessingVolUsd,
                        this.props.currencies['USD']
                      )}
                    </CustomModelListTd>
                  </Mobile>
                </>
              ),
              col3: (
                <CustomModelListTd bold right>
                  {formatCurrency(
                    this.props.tableBodyOptions.summary.totalFeesUsd,
                    this.props.currencies['USD']
                  )}
                </CustomModelListTd>
              ),
              col4: (
                <CustomModelListTd bold right>
                  ---
                </CustomModelListTd>
              )
            }}
          />
        )}
      </>
    );
  }
}
